import { computed, effect, EffectRef, Injectable } from "@angular/core";
import { CorpForm } from "@corporate-tailwind/corp-form";
import { OrderTrackingDto, OrderTrackingForSchema } from "../../model/order-tracking.model";
import { OrderTrackingState } from "../state/order-tracking.state";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: 'root' })
export class OrderTrackingService extends CorpForm<OrderTrackingDto> {
    orderTracking$ = computed(() => this._state.orderTracking());
    businessException$ = computed(() => this._state.businessException());

    loading$ = this._state.loading;

    private effectSignal: EffectRef;

    constructor(
        public _state: OrderTrackingState,
        public _translate: TranslateService
    ) {

        super(OrderTrackingForSchema, OrderTrackingForSchema)

        // 🔄 synchroniser le form -> signal (normalement dans ngonInit)
        // var valueChangeFormGroup = this.formGroup?.valueChanges.subscribe((value: any) => {
        //     this._state.patch(value)
        // });

        // 🔄 synchroniser le signal -> form
        this.effectSignal = effect(() => {
            const value = this._state.orderTracking();
            if (!value) return;
            this.safePatchValue(value)
        });
    }

    load(orderCode: string): void {
        const languageCode = this._translate.getCurrentLang();
        this._state.load(orderCode, languageCode);
    }

    unload() {
        this.effectSignal.destroy();
        this._state.unload();
    }

}
